export const EXTENSION_URL = "https://chrome.google.com/webstore/detail/valu-genie/imhagldanfpenmppknnppfbgaeddfech?authuser=0&hl=en-GB";